<div class="left-col-wrap" *ngIf="plan !== 'plan_premium'">
  <div class="current-plan-wrap" *ngIf="role !== 'guest'">
    <p class="small-text">
    You are currently using
    <strong class="bold">{{
      plan == "free"
        ? "Free Plan"
        : plan == "plan_advance"
        ? "Advance Plan"
        : "Premium Plan"
    }}</strong>
    </p>
  </div>
  
  <h3>Get more with <strong>TheKredible Pro Plan</strong></h3>
  <!-- <p class="desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> -->
  
  <div class="planbg advance" *ngIf="plan == 'free' && planInCart == undefined">
    <div class="tk-flex topwrap">
      <span class="plan-name">Advance Plan</span>
      <a href="/prices" class="link">Explore Plans
        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8319 6.08362C12.056 6.31604 12.056 6.68415 11.8319 6.91658L7.20333 11.7166C6.97332 11.9551 6.59348 11.962 6.35495 11.732C6.11641 11.502 6.10951 11.1222 6.33952 10.8836L9.98792 7.1001L0.599999 7.1001C0.268629 7.1001 -2.50526e-07 6.83147 -2.36042e-07 6.5001C-2.21557e-07 6.16873 0.268629 5.9001 0.599999 5.9001L9.98791 5.9001L6.33952 2.11658C6.10951 1.87804 6.11641 1.49821 6.35495 1.26819C6.59348 1.03818 6.97332 1.04508 7.20333 1.28362L11.8319 6.08362Z" fill="#0066FF"/>
        </svg>
      </a>
    </div>
    <div class="btm-wrap tk-flex">
      <div class="price-wrap">
        <span class="price"> {{ packages?.plan_advance?.price | currency:'INR':'symbol':'1.0-0' }}</span>
        <span class="actual-price"> INR 25,000 </span>
      </div>
      <button
        class="btn btn-dark-blue-bg" [disabled]="advanceButton || premiumButton"
        (click)="cartPlan('plan_advance')"
      >
        Add to Cart
      </button>
    </div>  
  </div>
  <div class="planbg premium"
    *ngIf="
      (plan == 'free' || plan == 'plan_advance') &&
      planInCart !== 'plan_premium'
    "
  >
    <div class="tk-flex topwrap">
      <span class="plan-name">Premium Plan</span>
      <a href="/prices" class="link">Explore Plans
        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8319 6.08362C12.056 6.31604 12.056 6.68415 11.8319 6.91658L7.20333 11.7166C6.97332 11.9551 6.59348 11.962 6.35495 11.732C6.11641 11.502 6.10951 11.1222 6.33952 10.8836L9.98792 7.1001L0.599999 7.1001C0.268629 7.1001 -2.50526e-07 6.83147 -2.36042e-07 6.5001C-2.21557e-07 6.16873 0.268629 5.9001 0.599999 5.9001L9.98791 5.9001L6.33952 2.11658C6.10951 1.87804 6.11641 1.49821 6.35495 1.26819C6.59348 1.03818 6.97332 1.04508 7.20333 1.28362L11.8319 6.08362Z" fill="#0066FF"/>
        </svg>
      </a>
    </div>
    <p class="offtext">Save upto 35% -- INR 6999 per Year</p>
    <div class="btm-wrap tk-flex">
      <div class="price-wrap">
        <span class="price"> {{ packages?.plan_premium?.price | currency:'INR':'symbol':'1.0-0' }}</span>
         <span class="actual-price"> INR 40,000</span>
      </div>
      <button
        class="btn btn-dark-blue-bg"   [disabled]="premiumButton"
        (click)="cartPlan('plan_premium')"
      >
        Add to Cart
      </button>
    </div>  
  </div>

  <!-- <div class="planbg report">
    <div class="tk-flex topwrap">
      <span class="plan-name">Reports Plan</span>
      <a href="" class="link">Explore Plans
        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8319 6.08362C12.056 6.31604 12.056 6.68415 11.8319 6.91658L7.20333 11.7166C6.97332 11.9551 6.59348 11.962 6.35495 11.732C6.11641 11.502 6.10951 11.1222 6.33952 10.8836L9.98792 7.1001L0.599999 7.1001C0.268629 7.1001 -2.50526e-07 6.83147 -2.36042e-07 6.5001C-2.21557e-07 6.16873 0.268629 5.9001 0.599999 5.9001L9.98791 5.9001L6.33952 2.11658C6.10951 1.87804 6.11641 1.49821 6.35495 1.26819C6.59348 1.03818 6.97332 1.04508 7.20333 1.28362L11.8319 6.08362Z" fill="#0066FF"/>
        </svg>
      </a>
    </div>
    <p class="offtext">Get 20% Off on your order</p>
    <div class="btm-wrap tk-flex">
      <div class="price-wrap">
        <span class="price">INR 5,990</span>
        <span class="actual-price"> INR 7,000</span>
      </div>
      <button class="btn btn-dark-blue-bg">
        Add to Cart
      </button>
    </div>  
  </div> -->
  
</div>
